import { AbstractControl, FormArray, ValidatorFn } from "@angular/forms";

export function AtLeastOneRequired(): ValidatorFn {
  return (formGroup: AbstractControl): { [key: string]: any } | null => {
    const hasAtLeastOneValue = Object.values(
      (formGroup as FormArray).controls
    ).some((control) => !!control.value);

    return hasAtLeastOneValue
      ? null
      : {
          "at-least-one-required": true,
        };
  };
}
